import Vue from 'vue'
import VueRouter from 'vue-router'
// 引用I18n
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const i18n = new VueI18n({
  locale: localStorage.getItem('Language') == null ? 'id' : localStorage.getItem('Language') == 1 ? 'en' : 'id', // 设置默认语言环境
  fallbackLocale: 'en', // 设置备选语言环境
  messages: loadLocaleMessages() // 加载语言环境信息
});
let MenuArr = [
  // Warrant Tools
  {
    path: '/WarrantTools',
    name: 'WarrantTools',
    component: () => import('@/views/Tools/index.vue'),
    meta: {
      name: i18n.t('navname1'),
    },

    children: [
      // Warrant Search
      {
        path: '/WarrantTools/WarrantSearch',
        name: 'WarrantSearch',
        component: () => import('@/views/Tools/Search/index.vue'),
        meta: {
          name: i18n.t('wsname'),
          title: i18n.t('wstitle'),
          title1: `${i18n.t('wsname')} | CGS International`,
          disclaimer: '',
          content: {
            keywords: '#warrantsearch #structuredwarrant #cgsinternational #pencarianwaran',
            description: ''
          }
        }
      },
      // Matrix Warrant
      {
        path: '/WarrantTools/MatrixWarrant',
        name: 'MatrixWarrant',
        component: () => import('@/views/Tools/Matrix/index.vue'),
        meta: {
          name: i18n.t('mwname'),
          title: i18n.t('mwtitle'),
          title1: `${i18n.t('mwname')} | CGS International`,
          disclaimer: '',
          content: {
            keywords: '#matrixwarrant #structuredwarrant #cgsinternational #waranmatrix',
            description: ''
          }
        }
      },
      // Warrant Detail
      {
        path: '/WarrantTools/WarrantDetail',
        name: 'WarrantDetail',
        component: () => import('@/views/Tools/Terms/index.vue'),
        meta: {
          name: i18n.t('wdname'),
          title: i18n.t('wdtitle'),
          title1: `${i18n.t('wdname')} | CGS International`,
          disclaimer: '',
          content: {
            keywords: '#warrantdetail #structuredwarrant #cgsinternational #detailwaran',
            description: ''
          }
        }
      },
      // Warrant Calculator
      {
        path: '/WarrantTools/WarrantCalculator',
        name: 'WarrantCalculator',
        component: () => import('@/views/Tools/Calculator/index.vue'),
        meta: {
          name: i18n.t('wcname'),
          title: i18n.t('wctitle'),
          title1: `${i18n.t('wcname')} | CGS International`,
          disclaimer: '',
          content: {
            keywords: '#warrantcalculator #structuredwarrant #cgsinternational #kalkulatorwaran',
            description: ''
          }
        }
      },
      // Underlying Chart
      {
        path: '/WarrantTools/UnderlyingChart',
        name: 'UnderlyingChart',
        component: () => import('@/views/Tools/Underlying/index.vue'),
        meta: {
          name: i18n.t('ucname'),
          title: i18n.t('uctitle'),
          title1: `${i18n.t('ucname')} | CGS International`,
          disclaimer: '',
          content: {
            keywords: '#underlyingchart #structuredwarrant #cgsinternational #grafikunderlying',
            description: ''
          }
        }
      },
    ]
  },
  // Watchlist
  {
    path: '/Watchlist',
    name: 'Watchlist',
    component: () => import('@/views/Watchlist/index.vue'),
    meta: {
      name: i18n.t('navname2'),
    },

    children: [
      // Warrant Movers
      {
        path: '/Watchlist/WarrantMovers',
        name: 'WarrantMovers',
        component: () => import('@/views/Watchlist/Movers/index.vue'),
        meta: {
          name: i18n.t('wmname'),
          title: i18n.t('wmtitle'),
          title1: `${i18n.t('wmname')} | CGS International`,
          disclaimer: '',
          content: {
            keywords: '#warrantmovers #structuredwarrant #cgsinternational #penggerakwaran',
            description: ''
          }
        }
      },
      // Warrant Highlights
      {
        path: '/Watchlist/WarrantHighlights',
        name: 'WarrantHighlights',
        component: () => import('@/views/Watchlist/Highlights/index.vue'),
        meta: {
          name: i18n.t('whname'),
          title: i18n.t('whtitle'),
          title1: `${i18n.t('whname')} | CGS International`,
          disclaimer: '',
          content: {
            keywords: '#warranthighlights #structuredwarrant #cgsinternational #penggerakwaran',
            description: ''
          }
        }
      },
      // Today Recap
      {
        path: '/Watchlist/TodayRecap',
        name: 'Today Recap',
        component: () => import('@/views/Watchlist/Today/index.vue'),
        meta: {
          name: i18n.t('trname'),
          title: i18n.t('trtitle'),
          title1: `${i18n.t('trname')} | CGS International`,
          disclaimer: '',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      // Weekly Recap
      {
        path: '/Watchlist/WeeklyRecap',
        name: 'WeeklyRecap',
        component: () => import('@/views/Watchlist/Weekly/index.vue'),
        meta: {
          name: i18n.t('wrname'),
          title: i18n.t('wrtitle'),
          title1: `${i18n.t('wrname')} | CGS International`,
          disclaimer: '',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      //Warrant News
      {
        path: '/Watchlist/WarrantNews',
        name: 'WarrantNews',
        component: () => import('@/views/Watchlist/News/index.vue'),
        meta: {
          name: i18n.t('wnname'),
          title: i18n.t('wntitle'),
          title1: `${i18n.t('wnname')} | CGS International`,
          disclaimer: '',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
    ]
  },
  // Publication
  {
    path: '/Publication',
    name: 'Publication',
    component: () => import('@/views/Publication/index.vue'),
    meta: {
      name: i18n.t('navname3'),
    },

    children: [
      // New Warrant
      {
        path: '/Publication/NewWarrant',
        name: 'NewWarrant',
        component: () => import('@/views/Publication/New/index.vue'),
        meta: {
          name: i18n.t('nwname'),
          title: i18n.t('nwtitle'),
          title1: `${i18n.t('nwname')} | CGS International`,
          disclaimer: '',
          content: {
            keywords: '#newwarrant #structuredwarrant #cgsinternational #waranbaru',
            description: ''
          }
        }
      },
      // Expiry Warrant
      {
        path: '/Publication/ExpiryWarrant',
        name: 'ExpiryWarrant',
        component: () => import('@/views/Publication/Expiry/index.vue'),
        meta: {
          name: i18n.t('ewname'),
          title: i18n.t('ewtitle'),
          title1: `${i18n.t('ewname')} | CGS International`,
          content: {
            keywords: '#expirywarrant #structuredwarrant #cgsinternational #waranjatuhtempo',
            description: ''
          }
        }
      },
      // Documents
      {
        path: '/Publication/Documents',
        name: 'Documents',
        component: () => import('@/views/Publication/Documents/index.vue'),
        meta: {
          name: i18n.t('dmname'),
          title: i18n.t('dmtitle'),
          title1: `${i18n.t('dmname')} | CGS International`,
          disclaimer: '',
          content: {
            keywords: '#documents #structuredwarrant #cgsinternational #dokumenwaran',
            description: ''
          }
        }
      },
      // Announcement
      {
        path: '/Publication/Announcement',
        name: 'Announcement',
        component: () => import('@/views/Publication/Announcement/index.vue'),
        meta: {
          name: i18n.t('amname'),
          title: i18n.t('amtitle'),
          title1: `${i18n.t('amname')} | CGS International`,
          disclaimer: '',
          content: {
            keywords: '#Announcement #structuredwarrant #cgsinternational #pengumuman',
            description: ''
          }
        }
      },

    ]
  },
  // Education
  {
    path: '/Education',
    name: 'Education',
    component: () => import('@/views/Education/index.vue'),
    meta: {
      name: i18n.t('navname4'),
    },

    children: [
      // New to Structured Warrant
      {
        path: '/Education/NewtoStructuredWarrant',
        name: 'NewtoStructuredWarrant',
        component: () => import('@/views/Education/Structured/index.vue'),
        meta: {
          name: i18n.t('hsname'),
          title: '',
          disclaimer: '',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      // Seminar
      {
        path: '/Education/Seminar',
        name: 'Seminar',
        component: () => import('@/views/Education/Seminar/index.vue'),
        meta: {
          name: 'Seminar',
          title: '',
          disclaimer: '',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      // F&Q
      {
        path: '/Education/F&Q',
        name: 'F&Q',
        component: () => import('@/views/Education/F&Q/index.vue'),
        meta: {
          name: 'FAQ',
          title: '',
          disclaimer: '',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      // Glossary
      {
        path: '/Education/Glossary',
        name: 'Glossary',
        component: () => import('@/views/Education/Glossary/index.vue'),
        meta: {
          name: i18n.t('gsname'),
          title: '',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      // E-book
      {
        path: '/Education/E-book',
        name: 'E-book',
        component: () => import('@/views/Education/E-book/index.vue'),
        meta: {
          name: 'E-Book',
          title: i18n.t('ebtitle'),
          disclaimer: '',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      // Gallery
      {
        path: '/Education/Gallery',
        name: 'Gallery',
        component: () => import('@/views/Education/Gallery/index.vue'),
        meta: {
          name: i18n.t('gename'),
          title: '',
          disclaimer: '',
          content: {
            keywords: '',
            description: ''
          }
        }
      },

    ]
  },
  // Contact
  {
    path: '/Contact',
    name: 'Contact',
    component: () => import('@/views/Contact/index.vue'),
    meta: {
      name: i18n.t('navname5'),
    },

    children: [
      // About Us
      {
        path: '/Contact/AboutUs',
        name: 'AboutUs',
        component: () => import('@/views/Contact/AboutUs/index.vue'),
        meta: {
          name: i18n.t('auname'),
          title: '',
          title1: `${i18n.t('auname')} | CGS International`,
          disclaimer: '',
          paging: true,
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      // Contact Us
      {
        path: '/Contact/ContactUs',
        name: 'ContactUs',
        component: () => import('@/views/Contact/ContactUs/index.vue'),
        meta: {
          name: i18n.t('cuname'),
          title: i18n.t('cutitle'),
          title1: `${i18n.t('cuname')} | CGS International`,
          disclaimer: '',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      // Disclaimer
      {
        path: '/Contact/Disclaimer',
        name: 'Disclaimer',
        component: () => import('@/views/Contact/Disclaimer/index.vue'),
        meta: {
          name: 'Disclaimer',
          title: '',
          disclaimer: '',
          content: {
            keywords: '',
            description: ''
          }
        }
      },

    ]
  },
]
$.ajax({
  type: "GET",
  url: process.env.VUE_APP_API + "GetMenu",
  data: { lang: localStorage.getItem('Language') || 1 },
  dataType: "json",
  success: (res) => {
    if (res.status === "SUCCESS") {
      for (let i = 0; i < res.data.length; i++) {
        if (MenuArr[i]) {
          MenuArr[i].meta.name = res.data[i].CTA_Label;
          for (let j = 0; j < res.data[i].Children.length; j++) {
            if (MenuArr[i].children[j]) {
              MenuArr[i].children[j].path = res.data[i].Children[j].CTA
              MenuArr[i].children[j].meta.name = res.data[i].Children[j].CTA_Label
              MenuArr[i].children[j].meta.title = res.data[i].Children[j].Description
              MenuArr[i].children[j].meta.title1 = `${res.data[i].Children[j].CTA_Label} | CGS International`
            }
          }
        }
      }
      // MenuArr[0].children.splice(1, 1)
      MenuArr[1].children.splice(2, 1)
    }
  },
  error: function (error) {
    console.log(error);
  }
});

$.ajax({
  type: "GET",
  url: process.env.VUE_APP_API + "GetAllDisclaimer",
  data: { lang: localStorage.getItem('Language') || 1 },
  dataType: "json",
  success: (res) => {
    if (res.status === "SUCCESS") {


      $.each(res.disclaimers, (i, c) => {
        $.each(MenuArr, (j, n) => {
          $.each(n.children, (j1, n1) => {
            if (c.URL == n1.name) {
              n1.meta.disclaimer = c.Disclaimer
            }
          })
        })
      })
    }
  },
  error: function (error) {
    console.log(error);
  }
});


Vue.use(VueRouter)

const routes = [
  // 路由重定向
  {
    path: '/',
    redirect: '/Home',
    hidden: true,
    meta: {
      name: '',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  // Home
  {
    path: '/Home',
    name: 'Home',
    component: () => import('@/views/Home/index.vue'),
    meta: {
      name: '',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  {
    path: '*',
    name: 'Error404',
    component: () => import('@/views/Error404/index.vue')
  },
  {
    path: '/SearchResult',
    name: 'SearchResult',
    component: () => import('@/views/SearchResult/index.vue'),
    meta: {
      name: 'Search Result',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  ...MenuArr
]

// 在全局前置守卫中设置标题


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title1) {
    document.title = to.meta.title1
  }
  window.scrollTo(0, 0)
  next()
})

export default router
